import POPULAR_COUNTRIES from "../PopularCities/data/popularCountries";

type City = { name: string; canonicalName: string };

function getCityCanonicalNames(countryShortName: string): City[] {
  const country = POPULAR_COUNTRIES.find((c) => c.shortName === countryShortName);
  if (!country) return [];
  return country.popular_cities.map((city) => ({
    name: city.name,
    canonicalName: city.canonical_name,
    name_zh: city.name_zh,
  }));
}

export const UK_CITY_CANONICAL_NAMES = getCityCanonicalNames("UK");
export const AU_CITY_CANONICAL_NAMES = getCityCanonicalNames("AUS");
export const IR_CITY_CANONICAL_NAMES = getCityCanonicalNames("IRE");
export const US_CITY_CANONICAL_NAMES = getCityCanonicalNames("USA");
export const CA_CITY_CANONICAL_NAMES = getCityCanonicalNames("CAN");
export const SP_CITY_CANONICAL_NAMES = getCityCanonicalNames("ESP");
export const GER_CITY_CANONICAL_NAMES = getCityCanonicalNames("GER");
export const FR_CITY_CANONICAL_NAMES = getCityCanonicalNames("FR");
export const SG_CITY_CANONICAL_NAMES = getCityCanonicalNames("SG");
export const NZ_CITY_CANONICAL_NAMES = getCityCanonicalNames("NZ");

export const COUNTRY_TO_TWO_CITIES: Record<string, City[]> = {
  "United Kingdom": UK_CITY_CANONICAL_NAMES.slice(0, 5),
  "United States": US_CITY_CANONICAL_NAMES.slice(0, 5),
  Australia: AU_CITY_CANONICAL_NAMES.slice(0, 5),
  Ireland: IR_CITY_CANONICAL_NAMES.slice(0, 5),
  Spain: SP_CITY_CANONICAL_NAMES.slice(0, 5),
  Canada: CA_CITY_CANONICAL_NAMES.slice(0, 5),
  Germany: GER_CITY_CANONICAL_NAMES.slice(0, 5),
  France: FR_CITY_CANONICAL_NAMES.slice(0, 5),
  Singapore: SG_CITY_CANONICAL_NAMES.slice(0, 5),
  "New Zealand": NZ_CITY_CANONICAL_NAMES.slice(0, 5),
};
